import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { State, Action } from './types'
import { initEvent } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'

const initialState: State = {
  payments: undefined,
  paymentStat: [],
  topSale: undefined,
  event: cloneDeep(initEvent),
  terminalProfit: undefined,
  profitEvent: cloneDeep(initEvent),
  returnSummaryData: [],
  orderDashboardEvent: cloneDeep(initEvent),
}

export default function(state: State = initialState, action: Action) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.getPaymentDashboardAction.request):
        draft.orderDashboardEvent = cloneDeep(initEvent)
        draft.orderDashboardEvent.IsLoading = true
        draft.payments = undefined
        return draft
      case getType(actions.getPaymentDashboardAction.success):
        response = action.payload

        draft.orderDashboardEvent.IsLoading = false
        draft.orderDashboardEvent.SubmitSuccess = true
        draft.payments = response.data
        return draft
      case getType(actions.getPaymentDashboardAction.failure):
        draft.orderDashboardEvent.IsLoading = false
        draft.orderDashboardEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getPaymentStatDashboardAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.paymentStat = []
        return draft
      case getType(actions.getPaymentStatDashboardAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.paymentStat = response.data
        return draft
      case getType(actions.getPaymentStatDashboardAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getTopSaleDashboardAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.topSale = undefined
        return draft
      case getType(actions.getTopSaleDashboardAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.topSale = response.data
        return draft
      case getType(actions.getTopSaleDashboardAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getSupplierDashboardAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.supplierData = undefined
        return draft
      case getType(actions.getSupplierDashboardAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.supplierData = response.data
        return draft
      case getType(actions.getSupplierDashboardAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getReturnSummaryDashboardAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.returnSummaryData = []
        return draft
      case getType(actions.getReturnSummaryDashboardAction.success):
        response = action.payload
        draft.event.IsLoading = false
        draft.event.SubmitSuccess = true
        draft.returnSummaryData = response?.data || []
        return draft
      case getType(actions.getReturnSummaryDashboardAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getTerminalProfitAction.request):
        draft.profitEvent = cloneDeep(initEvent)
        draft.profitEvent.IsLoading = true
        draft.terminalProfit = undefined
        return draft
      case getType(actions.getTerminalProfitAction.success):
        response = action.payload
        draft.profitEvent.IsLoading = false
        draft.profitEvent.SubmitSuccess = true
        draft.terminalProfit = response.data
        return draft
      case getType(actions.getTerminalProfitAction.failure):
        draft.profitEvent.IsLoading = false
        draft.profitEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.clearEventAction):
        draft.event = cloneDeep(initEvent)
        draft.profitEvent = cloneDeep(initEvent)
        return draft
      default:
        return state
    }
  })
}
